/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Affiliates_TeamInputs */

const en_contact_affiliates_team = /** @type {(inputs: Contact_Affiliates_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact affiliates team`)
};

const es_contact_affiliates_team = /** @type {(inputs: Contact_Affiliates_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactar al equipo de afiliados`)
};

const fr_contact_affiliates_team = /** @type {(inputs: Contact_Affiliates_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacter l'équipe d'affiliation`)
};

const de_contact_affiliates_team = /** @type {(inputs: Contact_Affiliates_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affiliate-Team kontaktieren`)
};

const ja_contact_affiliates_team = /** @type {(inputs: Contact_Affiliates_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アフィリエイトチームに連絡`)
};

const zh_contact_affiliates_team = /** @type {(inputs: Contact_Affiliates_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系推广团队`)
};

const ar_contact_affiliates_team = /** @type {(inputs: Contact_Affiliates_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اتصل بفريق التسويق بالعمولة`)
};

const id_contact_affiliates_team = /** @type {(inputs: Contact_Affiliates_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi tim afiliasi`)
};

const it_contact_affiliates_team = /** @type {(inputs: Contact_Affiliates_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatta il team affiliati`)
};

const ru_contact_affiliates_team = /** @type {(inputs: Contact_Affiliates_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связаться с партнерским отделом`)
};

const pt_contact_affiliates_team = /** @type {(inputs: Contact_Affiliates_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatar equipe de afiliados`)
};

const ko_contact_affiliates_team = /** @type {(inputs: Contact_Affiliates_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어필리에이트 팀에 연락하기`)
};

/**
* | output |
* | --- |
* | "Contact affiliates team" |
*
* @param {Contact_Affiliates_TeamInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const contact_affiliates_team = /** @type {((inputs?: Contact_Affiliates_TeamInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Affiliates_TeamInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_affiliates_team(inputs)
	if (locale === "es") return es_contact_affiliates_team(inputs)
	if (locale === "fr") return fr_contact_affiliates_team(inputs)
	if (locale === "de") return de_contact_affiliates_team(inputs)
	if (locale === "ja") return ja_contact_affiliates_team(inputs)
	if (locale === "zh") return zh_contact_affiliates_team(inputs)
	if (locale === "ar") return ar_contact_affiliates_team(inputs)
	if (locale === "id") return id_contact_affiliates_team(inputs)
	if (locale === "it") return it_contact_affiliates_team(inputs)
	if (locale === "ru") return ru_contact_affiliates_team(inputs)
	if (locale === "pt") return pt_contact_affiliates_team(inputs)
	return ko_contact_affiliates_team(inputs)
});